import React, { useMemo } from 'react';
import { getDefaultForCountry, Languages } from '@merchant-portal/mp-models';
import { get } from 'lodash';
import { TranslationContext, useLocaleContext } from '../../context';
export const TranslationProvider = ({ translations, children }) => {
    const { countryCode, language } = useLocaleContext();
    const currentLanguageCode = useMemo(() => {
        const languageCode = language || getDefaultForCountry(countryCode);
        if (Object.values(Languages).every((validLanguageCode) => validLanguageCode !== languageCode)) {
            return Languages.SWEDISH;
        }
        return languageCode;
    }, [language, countryCode]);
    const translationProviderValue = useMemo(() => ({
        getText: (label) => {
            const element = get(translations[currentLanguageCode], label);
            const fallbackElement = !element &&
                Languages.SWEDISH !== currentLanguageCode &&
                get(translations[Languages.SWEDISH], label);
            return element || fallbackElement || '';
        },
    }), [currentLanguageCode]);
    return (React.createElement(TranslationContext.Provider, { key: `${language}-${countryCode}`, value: translationProviderValue }, children));
};
